"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _vehiclesCompareFooter = _interopRequireDefault(require("../vehicles-compare-footer"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config,
    market: state.Config.market,
    // unused
    language: state.Config.language,
    // unused
    countryCode: state.Config.market,
    // unused
    defaultLang: state.Config.defaultLang,
    // unused
    routePathMapping: state.routePathMapping,
    vehicleSelectedList: state.vehicleCompare.vehicleSelectedList
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(_vehiclesCompareFooter["default"]);

exports["default"] = _default;